import { forwardRef } from "react";
import Select from "react-select";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./SelectInput.module.scss";

interface SelectInputProps {
  name: string;
  placeholder?: string;
  className?: string;
  classNamePrefix?: string;
  options: {
    value?: string;
    label?: string;
  }[];
  isSearchable?: boolean;
  value: string | string[];
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  components?: { Menu: any };
  formatOptionLabel?: any;
  maxMenuHeight?: number;
  isMulti?: boolean;
}

const SelectInput = forwardRef(
  (
    {
      className,
      options,
      value,
      onChange = () => {},
      isMulti,
      ...rest
    }: SelectInputProps,
    ref: any
  ) => {
    const cls = classNameGenerator(styles);

    const _value = isMulti
      ? options?.filter((option) => value?.includes(option?.value || "")) || []
      : options?.find((option) => option.value === value) || null;

    return (
      <Select
        ref={ref}
        options={options}
        value={_value}
        onChange={(val: any) => {
          if (Array.isArray(val)) {
            onChange(val?.map((v) => v.value));
          } else {
            onChange(val?.value || "");
          }
        }}
        className={clsx(cls("selectInput"), className)}
        classNamePrefix="selectInput"
        isMulti={isMulti}
        {...rest}
        unstyled
      />
    );
  }
);

SelectInput.displayName = "SelectInput";

export default SelectInput;
